/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { BoardOrgSelectPermLevelView } from 'app/scripts/views/board-menu/BoardOrgSelectPermLevelView';
import { BoardSelectOrganizationView } from 'app/scripts/views/board-menu/BoardSelectOrganizationView';
import { PopOver } from 'app/scripts/views/lib/PopOver';

interface BoardSelectOrganizationForPermChangeView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disableNone: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
}

// @ts-expect-error TS(2507): Type 'typeof BoardSelectOrganizationView' is not a... Remove this comment to see the full error message
class BoardSelectOrganizationForPermChangeView extends BoardSelectOrganizationView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize(options: any) {
    this.disableNone = options != null ? options.disableNone : undefined;
    return super.initialize(...arguments);
  }

  render() {
    super.render(...arguments);
    if (this.disableNone) {
      $('.js-submit', this.$el)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showOrgBoardVisPerms(organization: any, idOrganizationSource: any) {
    // we're not in a context where we want to do this, so error instead
    return PopOver.pushView({
      // @ts-expect-error TS(2351): This expression is not constructable.
      view: new BoardOrgSelectPermLevelView({
        model: this.model,
        organization,
        idOrganizationSource,
        modelCache: this.modelCache,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submit(e: any) {
    return super.submit(...arguments);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  canAddToOrg(organization: any) {
    return (
      !organization.isFeatureEnabled('restrictVis') ||
      organization.canSetVisibility('org')
    );
  }

  changeOrg(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    idOrganizationTarget: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    idOrganizationSource: any,
    settings = {},
  ) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    settings['prefs/permissionLevel'] = 'org';
    return super.changeOrg(
      idOrganizationTarget,
      idOrganizationSource,
      settings,
    );
  }

  orgSelected() {
    super.orgSelected(...arguments);
    if (this.disableNone) {
      if ($('.js-org', this.$el).val() === '') {
        return $('.js-submit', this.$el)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      } else {
        return $('.js-submit', this.$el)
          .removeClass('disabled')
          .prop('disabled', false);
      }
    }
  }
}

export { BoardSelectOrganizationForPermChangeView };
